export default {
  userSubscription: {},
  isPlan360: false,
};
